import * as OM from '@/model';
import { apiurl } from '@/config';

class _DownloadServices  {
    
    downloadLog(fileName: string) {
        window.open(apiurl + 'api/JobResultLog/DownloadLog?fileName=' + fileName, '_blank');
    }
    
}

export let DownloadServices = new _DownloadServices();